export function isWeChatBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /micromessenger/i.test(ua);
}

